import { __decorate } from "tslib";
import { attr } from '@microsoft/fast-element';
import { ChameleonElementMixin } from '../common/mixin';
import { Anchor } from '@microsoft/fast-foundation';
export class ButtonLinkComponent extends ChameleonElementMixin(Anchor) {
    constructor() {
        super(...arguments);
        this.size = 'medium';
        this.variant = 'primary';
        this.disabled = false;
        this.fullwidth = false;
    }
}
__decorate([
    attr
], ButtonLinkComponent.prototype, "size", void 0);
__decorate([
    attr
], ButtonLinkComponent.prototype, "variant", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ButtonLinkComponent.prototype, "disabled", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ButtonLinkComponent.prototype, "fullwidth", void 0);
